import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n		padding: 32px;\n	"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n	border-radius: 16px;\n	padding: 20px;\n	background: ",
        ";\n	box-shadow: -8px 9px 48px rgba(218, 224, 236, 0.22);\n	width: 100%;\n	max-width: 670px;\n	",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n	"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n	border-radius: 8px;\n	background: ",
        ";\n	padding: 16px;\n	",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n		text-align: left;\n	"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n	margin: 0;\n	",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n	display: flex;\n	flex-direction: column;\n	justify-content: center;\n	",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n	flex-basis: 50%;\n	display: flex;\n	max-width: 256px;\n	padding: 12px 0;\n	border-bottom: 2px solid ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n	line-height: 1;\n	margin: 0 0 0 8px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n	width: 16px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { Translation } from "~/components/Translation";
import Check from "~/components/MaterialIcons/Check";
import theme from "~/styles/theme";
import { ResponsiveText } from "~/components/Marketing";
import { media } from "~/styles/mixins";
var streamYardFeatureList = [
    /*#__PURE__*/ _jsx(Translation, {
        tid: "landingWhyStreamYard.block.streamYardFeatures.onScreen"
    }, "landingWhyStreamYard.block.streamYardFeatures.onScreen"),
    /*#__PURE__*/ _jsx(Translation, {
        tid: "landingWhyStreamYard.block.streamYardFeatures.logos"
    }, "landingWhyStreamYard.block.streamYardFeatures.logos"),
    /*#__PURE__*/ _jsx(Translation, {
        tid: "landingWhyStreamYard.block.streamYardFeatures.multistream"
    }, "landingWhyStreamYard.block.streamYardFeatures.multistream"),
    /*#__PURE__*/ _jsx(Translation, {
        tid: "landingWhyStreamYard.block.streamYardFeatures.preRecorded"
    }, "landingWhyStreamYard.block.streamYardFeatures.preRecorded"),
    /*#__PURE__*/ _jsx(Translation, {
        tid: "landingWhyStreamYard.block.streamYardFeatures.onScreenComments"
    }, "landingWhyStreamYard.block.streamYardFeatures.onScreenComments"),
    /*#__PURE__*/ _jsx(Translation, {
        tid: "landingWhyStreamYard.block.streamYardFeatures.fullHD"
    }, "landingWhyStreamYard.block.streamYardFeatures.fullHD"),
    /*#__PURE__*/ _jsx(Translation, {
        tid: "landingWhyStreamYard.block.streamYardFeatures.greenScreen"
    }, "landingWhyStreamYard.block.streamYardFeatures.greenScreen"),
    /*#__PURE__*/ _jsx(Translation, {
        tid: "landingWhyStreamYard.block.streamYardFeatures.downloadRecordings"
    }, "landingWhyStreamYard.block.streamYardFeatures.downloadRecordings"),
    /*#__PURE__*/ _jsx(Translation, {
        tid: "landingWhyStreamYard.block.streamYardFeatures.customRTMP"
    }, "landingWhyStreamYard.block.streamYardFeatures.customRTMP"),
    /*#__PURE__*/ _jsx(Translation, {
        tid: "landingWhyStreamYard.block.streamYardFeatures.screenSharing"
    }, "landingWhyStreamYard.block.streamYardFeatures.screenSharing"),
    /*#__PURE__*/ _jsx(Translation, {
        tid: "landingWhyStreamYard.block.streamYardFeatures.support"
    }, "landingWhyStreamYard.block.streamYardFeatures.support"),
    /*#__PURE__*/ _jsx(Translation, {
        tid: "landingWhyStreamYard.block.streamYardFeatures.separateAudio"
    }, "landingWhyStreamYard.block.streamYardFeatures.separateAudio"),
    /*#__PURE__*/ _jsx(Translation, {
        tid: "landingWhyStreamYard.block.streamYardFeatures.customBanners"
    }, "landingWhyStreamYard.block.streamYardFeatures.customBanners"),
    /*#__PURE__*/ _jsx(Translation, {
        tid: "landingWhyStreamYard.block.streamYardFeatures.layoutTemplates"
    }, "landingWhyStreamYard.block.streamYardFeatures.layoutTemplates"), 
];
var StreamYardFeatureWrap = styled.div.withConfig({
    componentId: "sc-b252f8f6-0"
})(_templateObject1(), function(props) {
    return props.theme.colors.background.white;
}, media.xLarge(_templateObject()));
var StyledHeaderWrap = styled.div.withConfig({
    componentId: "sc-b252f8f6-1"
})(_templateObject3(), function(props) {
    return props.theme.colors.background.slate;
}, media.xLarge(_templateObject2()));
var FeatureListHeaderText = styled(ResponsiveText).withConfig({
    componentId: "sc-b252f8f6-2"
})(_templateObject5(), media.large(_templateObject4()));
var FeatureListWrap = styled.div.withConfig({
    componentId: "sc-b252f8f6-3"
})(_templateObject7(), media.medium(_templateObject6()));
var FeatureListItemWrap = styled.div.withConfig({
    componentId: "sc-b252f8f6-4"
})(_templateObject8(), function(props) {
    return props.theme.colors.background.slate;
});
var StyledListItemText = styled(ResponsiveText).withConfig({
    componentId: "sc-b252f8f6-5"
})(_templateObject9());
var CheckWrap = styled.div.withConfig({
    componentId: "sc-b252f8f6-6"
})(_templateObject10());
var StreamYardFeatureList = function() {
    return /*#__PURE__*/ _jsxs(StreamYardFeatureWrap, {
        children: [
            /*#__PURE__*/ _jsx(StyledHeaderWrap, {
                children: /*#__PURE__*/ _jsx(FeatureListHeaderText, {
                    textAlign: "center",
                    component: "h2",
                    variant: "h5",
                    children: /*#__PURE__*/ _jsx(Translation, {
                        tid: "landingWhyStreamYard.block.streamYardFeatures.header"
                    })
                })
            }),
            /*#__PURE__*/ _jsx(FeatureListWrap, {
                children: streamYardFeatureList.map(function(listItem, index) {
                    return /*#__PURE__*/ _jsxs(FeatureListItemWrap, {
                        children: [
                            /*#__PURE__*/ _jsx(CheckWrap, {
                                children: /*#__PURE__*/ _jsx(Check, {
                                    fill: theme.colors.primary.main,
                                    size: "16"
                                })
                            }),
                            /*#__PURE__*/ _jsx(StyledListItemText, {
                                variant: "body",
                                children: listItem
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
export default StreamYardFeatureList;
